export const config = {
    localApiUrl: "https://stagingapi.sumoeats.co.uk",
    success:"You were added to List.!",
    thankyou:"Your preference added.!",
};